import { render, staticRenderFns } from "./callPoliceLog.vue?vue&type=template&id=2237c34e&scoped=true"
import script from "./callPoliceLog.vue?vue&type=script&lang=ts"
export * from "./callPoliceLog.vue?vue&type=script&lang=ts"
import style0 from "./callPoliceLog.vue?vue&type=style&index=0&id=2237c34e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2237c34e",
  null
  
)

export default component.exports